import { Component } from "@angular/core";
import { ModalSetting } from "@shared/components/modal/modal-setting";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ProviderSettingsEditComponent } from "../edit/provider-settings-edit.component";

@Component({
  selector: 'app-provider-settings-display',
  templateUrl: './provider-settings-display.component.html'
})
export class ProviderSettingsDisplayComponent {
  modal: BsModalRef | null = null;

  constructor(private modalService: BsModalService) { }

  edit() {
    this.openModal(ProviderSettingsEditComponent);
  }

  openModal(template: any) {
    let content: any = {
      cancel: () => this.closeModal(),
      saved: () => this.closeModal(),
    }
    this.modal = this.modalService.show(
      template,
      ModalSetting.createLargeModal(content)
    );
  }

  closeModal() {
    this.modal?.hide();
  };
}